export default {
    baseStyle: {
        header: {
            fontSize: '14px',
            fontFamily: 'body',
            fontWeight: 600,
            px: 0,
            py: 0
        },
        dialog: {
            p: '24px',
            borderRadius: '0',
            bg: 'white'
        },
        body: {
            fontSize: '13px',
            px: 0,
            py: '16px'
        },
        closeButton: {
            top: '18px',
            right: '16px'
        }
    },
    sizes: {
        small: {
            dialog: {
                flexBasis: '400px',
                maxWidth: 'calc(100vw - 16px)'
            }
        },
        medium: {
            dialog: {
                width: ['100vw', null, '700px']
            }
        },
        large: {
            dialog: {
                width: ['100vw', null, null, '1000px']
            }
        }
    }
}
